import React, { forwardRef } from 'react';
import styles from './checkbox.module.css';
import { Label } from '../label/label';
import classNames from 'classnames';

// Extend the props to include all input attributes
interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  type: 'checkbox' | 'radio';
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      className,
      type,
      disabled,
      label,
      defaultChecked,
      checked,
      value,
      ...props
    },
    ref
  ) => {
    return (
      <Label className={styles.label}>
        <input
          type="checkbox"
          className={`sr-only   ${className}`}
          defaultChecked={defaultChecked}
          checked={checked}
          disabled={disabled}
          value={value}
          {...props}
          ref={ref}
        />
        <span
          className={classNames({
            [styles.checkbox]: type === 'checkbox',
            [styles.checkbox__checked]:
              type === 'checkbox' &&
              (typeof value === 'boolean' ? value : checked),
            [styles.radio]: type === 'radio',
            [styles.radio__checked]:
              type === 'radio' &&
              (typeof value === 'boolean' ? value : checked),
            [styles.disabled]: disabled,
          })}
        >
          {checked || (typeof value === 'boolean' && value === true) ? (
            <span
              className={classNames(styles.checkmark, {
                [styles['checkmark--radio']]: type === 'radio',
                [styles['checkmark--checkbox']]: type === 'checkbox',
              })}
            ></span>
          ) : null}
        </span>
        {label}
      </Label>
    );
  }
);
